import { Program } from '../../../Common/enums';

export function stringifyProgram(program: Program): string {
    switch (program) {
        case Program.Tanke:
            return 'tanke';
        case Program.Pres:
            return 'pres';
        case Program.Stress:
            return 'stress';
    }
}

export function parseProgram(value: string): Program | null {
    switch (value) {
        case 'tanke':
            return Program.Tanke;
        case 'pres':
            return Program.Pres;
        case 'stress':
            return Program.Stress;
        default:
            return null;
    }
}
